import { createFileRoute, redirect } from '@tanstack/react-router';
import { buildLegacyAmendmentRedirect } from '@/pages/contracts/lib/contract-routes';

export const Route = createFileRoute('/admin/_layout/contracts/_layout/')({
  // Il link di prima alla variazione (`?commercialRequestId&parentContractId`)
  // apre la rotta di creazione, che è dove ora vive il form.
  beforeLoad: ({ search }) => {
    const target = buildLegacyAmendmentRedirect('admin', search);
    if (target) throw redirect(target);
  },
  component: () => null, // La lista la rende il layout.
});
